var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{staticClass:"code-btn",attrs:{"native-type":"button"},on:{"click":_vm.clickHandler}},[(_vm.disabled)?_c('span',{staticClass:"off"},[_vm._v(_vm._s(_vm.sec)+"S")]):_c('span',{staticClass:"on"},[_vm._v(_vm._s(_vm.defaultText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }